export enum NotificationAveragingEnum {
    Instantaneous = 0,
    TimeWeightedAverage = 1,
    Count = 2,
    Mean = 3,
    Median = 4,
    RepeatedExceedance = 5,
}
